<template>
 <div class="cont">
  <div class="toutu">
    <img src="../../assets/huiyuanjianzheng.jpg"></div>
  <div class="div_t">
    <div style="text-align: center;">
	<span class="hyjz">会员见证</span><br>
    <br>
	<span style="color:#ffcb8d;"><span><span style="font-family: 微软雅黑; font-size: 16px;">—————————————————————————————————————————————————————</span></span></span><br>
	<br>
	<div class="jianzheng_div">
		<br>
		<br>
		<img class="jianzheng_img" src="../../assets/1-1Z5241P932131.png">
		<p class="jianzheng_txt">
			会员买家秀：桂花燕窝</p>
	</div>
	<div class="jianzheng_div">
		<img class="jianzheng_img" src="../../assets/1-1Z5241Q030362.png">
		<p class="jianzheng_txt">
			会员买家秀：榴莲燕窝</p>
	</div>
	<div class="jianzheng_div">
		<img class="jianzheng_img" src="../../assets/1-1Z603162U2926.jpg" style="width: 558px; height: 419px;">
		<p class="jianzheng_txt">
			会员买家秀：火龙果燕窝</p>
	</div>
	<div class="jianzheng_div">
		<img class="jianzheng_img" src="../../assets/1-1Z603162Z4C0.jpg" style="width: 558px; height: 558px;">
		<p class="jianzheng_txt">
			会员买家秀：玫瑰燕窝</p>
	</div>
	<div class="jianzheng_div">
		<img class="jianzheng_img" src="../../assets/1-1Z60316291A29.jpg" style="width: 558px; height: 558px;">
		<p class="jianzheng_txt">
			会员买家秀：星空燕窝</p>
	</div>
</div>
<br>

  </div>
</div>
</template>

<script>
	
export default {
  name: 'vipHyjj',
  data () {
    return {
      
    }
  },
  methods:{
			
		}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.div_t {
    width: 1120px;
    margin: auto;
    margin-top: 84px;
    margin-bottom: 86px;
}
.toutu {
    width: 1120px;
    margin: auto;
}

.toutu img {
    width: 100%;
}

.cont {
    width: 1120px;
    margin: 0 auto;
    height: 100%;

}
.hyjz{ font-size: 20px;}
.logo {
    margin-left: 449px;
    margin-top: 72px;
}


.div_t_div {
    width: 1120px;
    height: 500px;
    position: relative;
}

.div_t_div_img1 {
    width: 500px;
    position: absolute;
}

.div_t_div_img2 {
    position: absolute;
    margin-left: 400px;
    top: 62px;
    z-index: 1;
    height: 280px;
    width: 700px;
}

.text1 {
    position: absolute;
    margin-left: 580px;
    top: 94px;
    z-index: 3;
    width: 500px;
}

.text1 li {
    display: block;
    font-size: 26px;
    letter-spacing: 3px;
    color: #1b1b1b;
    margin-left: 0px;
}

.hrs {
    height: 1px;
    border: none;
    border-top: 1px solid #35b597;
    width: 426px;
    margin-left: 0px;
    margin-top: 16px;
    float: left;
}

.text1_p {
    font-size: 16px;
    text-indent: 2em;
    float: right;
    margin-right: 50px;
    margin-top: 10px;
    line-height: 39px;
    color: #1b1b1b;
    letter-spacing: 1px;
}

.div_c {
    width: 1120px;
    margin: 0 auto;
    margin-top: 0px;
    height: 500px;
    position: relative;
}

.div_c_img1 {
    width: 500px;
    margin-left: 620px;
    position: absolute
}

.div_c_img2 {
    position: absolute;
    top: 50px;
    z-index: 1;
    height: 280px;
    margin-left: 50px;
    width: 700px;
}

.text2 {
    position: absolute;
    /*margin-left: 100px;*/
    top: 82px;
    z-index: 3;
    width: 500px;
}

.text2_li {
    display: block;
    font-size: 26px;
    letter-spacing: 5px;
    color: #1b1b1b;
}

.text2_p {
        font-size: 16px;
    text-indent: 2.3em;
    line-height: 39px;
    color: #1b1b1b;
    margin-top: 32px;
    margin-left: 0px;
    letter-spacing: 3px;
}
.jianzheng_div {
    width: 633px;
    /* background: #bbbec3; */
    box-shadow: 1px 2px 10px #999;
    margin-left: auto;
    margin-right: auto;
    padding-top: 19px;
    padding-bottom: 5px;
    margin-bottom: 70px;
}
.jianzheng_img {
    width: 600px;
    margin-left: auto;
    margin-right: auto;
    display: block;
}
.jianzheng_txt {
    color: #333;
    margin-top: 11px;
    font-size: 19px;
    text-align: center;
}
@media(max-width: 750px) {
   .cont{width:100%; margin: 0 auto;}
   .toutu{ width: 100%; overflow: hidden}
   .toutu img{ width: 100%; margin-left: 0%;}
  .div_t{ width: 690px; overflow: hidden; margin-top: 30px;}
  table{ width:690px;}
  .pic{ height:280px;}
  .spantext{ font-size: 24px}
  .jianzheng_txt{ font-size: 30px; line-height: 2}
  .hyjz{ font-size: 32px;}
 
}     
</style>



// WEBPACK FOOTER //
// src/components/vip/hyjj.vue